export default class Query {
    constructor(panel, filters, dateRange) {
        this.aggregateFact = panel.aggregateFact;
        this.column = panel.column;
        this.dataset = panel.dataset;
        this.dateRange = dateRange;
        this.groupBy = panel.groupBy;
        this.filters = filters;
    }

    isEqual(query) {
        return query.dataset === this.dataset
            && query.column === this.column
            && query.dateRange === this.dateRange
            && query.groupBy === this.groupBy
            && query.filters === this.filters;
    }
}
